import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { id: "services", label: "Services", testid: "nav-link-services" },
  { id: "parts", label: "Parts", testid: "nav-link-parts" },
  { id: "inventory", label: "Inventory", testid: "nav-link-inventory" },
  { id: "about", label: "About", testid: "nav-link-about" },
  { id: "gallery", label: "Gallery", testid: "nav-link-gallery" },
  { id: "testimonials", label: "Testimonials", testid: "nav-link-testimonials" },
];

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Navbar({ onBook }) {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-[#263342]/70 bg-[#0A0D12]/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-brand-logo"
          onClick={() => window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
        >
          <Logo size={34} />
          <span className="font-display font-bold text-xl tracking-[0.18em] uppercase text-slate-100 group-hover:text-crimson transition-colors">
            Werkhaus
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => scrollToSection(l.id)}
              className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400 hover:text-slate-100 transition-colors"
            >
              {l.label}
            </button>
          ))}
          <Link
            to="/admin"
            data-testid="nav-link-admin"
            className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500 hover:text-slate-100 transition-colors"
          >
            Admin
          </Link>
          <button
            data-testid="nav-booking-button"
            onClick={onBook}
            className="bg-crimson text-white font-display font-semibold uppercase tracking-widest text-sm px-6 py-2.5 hover:-translate-y-0.5 transition-transform shadow-[0_0_0_0_rgba(255,56,21,0.4)] hover:shadow-[0_0_24px_0_rgba(255,56,21,0.4)]"
          >
            Book Service
          </button>
        </nav>

        <button
          data-testid="nav-mobile-menu-button"
          className="lg:hidden text-slate-200"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#263342] bg-[#0A0D12] px-5 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-${l.testid}`}
              onClick={() => { setOpen(false); scrollToSection(l.id); }}
              className="text-left font-mono text-xs uppercase tracking-[0.25em] text-slate-300"
            >
              {l.label}
            </button>
          ))}
          <Link to="/admin" data-testid="nav-mobile-admin" className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
            Admin
          </Link>
          <button
            data-testid="nav-mobile-booking-button"
            onClick={() => { setOpen(false); onBook(); }}
            className="bg-crimson text-white font-display font-semibold uppercase tracking-widest text-sm px-6 py-3"
          >
            Book Service
          </button>
        </div>
      )}
    </header>
  );
}
